import * as Sentry from '@sentry/angular';

export function sanitizeSentryEvent(
  event: Sentry.ErrorEvent,
  hint: Sentry.EventHint
): Sentry.ErrorEvent | PromiseLike<Sentry.ErrorEvent | null> | null {
  if (event.request?.headers) {
    delete event.request.headers['Authorization'];
    delete event.request.headers['authorization'];
    delete event.request.headers['X-Api-Key'];
  }

  if (event.request?.cookies) {
    event.request.cookies = {};
  }

  if (event.request?.url) {
    event.request.url = event.request.url.split('?')[0];
  }

  return event;
}
